import { buildDocsTrackingMarker } from '@realadvisor/transform/docs-tracking-marker';

import type { Doc_Template_Type_Enum_Enum } from '@graphql/__generated__/graphql';
import { docs_direct_origin, docs_origin, links_origin } from '@shared/config';
import type { Language } from '@shared/LocaleContext';
import { toGlobalId } from '@shared/utils/global-id';

export const getGlobalTemplateId = (templateId: string) =>
  toGlobalId('DocTemplate', templateId);

export const createDocumentUrl = (
  templateId: string,
  documentId: string,
  language: Language,
): URL => {
  const documentUrl = new URL('/document', docs_origin);
  documentUrl.searchParams.set('templateId', templateId);
  documentUrl.searchParams.set('documentId', documentId);
  documentUrl.searchParams.set('language', language);
  return documentUrl;
};

export const createDocumentUrlForTemplate = (
  templateId: string,
  documentId: string,
  language: Language,
): URL =>
  createDocumentUrl(getGlobalTemplateId(templateId), documentId, language);

export const createTrackingMarkerUrl = (
  docsUrl: string,
  documentType: Doc_Template_Type_Enum_Enum,
  channel: string = 'email',
): string =>
  buildDocsTrackingMarker(docsUrl, documentType, channel, links_origin);

export const createDataUrl = (
  documentId: string,
  type: Doc_Template_Type_Enum_Enum | undefined,
  language: Language,
  descriptionLanguage?: Language | null,
): URL => {
  const url = new URL('/data', docs_direct_origin);
  url.searchParams.set('documentId', documentId);

  if (type) {
    url.searchParams.set('type', type);
  }
  url.searchParams.set('language', language);
  if (descriptionLanguage) {
    url.searchParams.set('descriptionLanguage', descriptionLanguage);
  }
  return url;
};
